module.exports = __webpack_public_path__ + "static/media/Avatars_Female-08.a33e0b32.png";